/* eslint-disable @typescript-eslint/no-empty-function */
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { CategoryTree } from '@mercadoni/sinister/dist/cjs/categoryTree'
import { CategoryModel } from '@mercadoni/sinister/dist/lib/src/entities/category'
import { CategoryTree as ICategoryTree } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { FC, useState } from 'react'
import { Store } from '~types/index'
import Text from './decorators/Text'
import styles from './layout.module.css'

const modalStyles = `
  &.ant-modal {
    top: 92px;
    left: min(180px, 15vw);
  }
`

interface CategoriesLayoutProps {
  clientId: string
  clientCategoryTree: ICategoryTree
  className?: string
  initialCategories?: CategoryModel[]
  onCategoryOnClick: () => void
  onPromotionsOnClick: () => void
  store: Store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copies: any
  isLightBackground: boolean
  isMobile: boolean
}

const CategoriesLayout: FC<CategoriesLayoutProps> = (props) => {
  const {
    clientId,
    clientCategoryTree,
    className,
    initialCategories,
    onCategoryOnClick,
    onPromotionsOnClick,
    store,
    copies,
    isLightBackground,
    isMobile,
  } = props
  const [openCategoryTree, setOpenCategoryTree] = useState(() => () => {})
  const { header: copy } = copies

  const buttonClassName = isMobile
    ? `${styles.buttonMobile} ${className || ''}`
    : `${styles.button} ${
        isLightBackground ? styles.lightBackground : styles.darkBackground
      } ${className || ''}`

  return (
    <>
      <CategoryTree
        clientId={clientId}
        storeReference={store.reference}
        copies={copies}
        onCategoryOnClick={onCategoryOnClick}
        onPromotionsOnClick={onPromotionsOnClick}
        setOpenCategoryTree={setOpenCategoryTree}
        {...clientCategoryTree}
        modalStyles={modalStyles}
        initialCategories={initialCategories}
      />
      <button onClick={() => openCategoryTree()} className={buttonClassName}>
        <Icon className="ph-squares-four" size={24} aria-label="Categories" />
        {!isMobile && <Text text={copy?.categories} />}
      </button>
    </>
  )
}

export default CategoriesLayout
